export const navigation = {
  state: {
    category: null,
    items: [],
  },
  mutations: {
    setNavItems(state, categories) {
      let nav = [{ route: 'about' }]

      categories.forEach((category) => {
        nav.push({
          category: category.id,
          route: 'category',
        })
      })

      nav.push({ route: 'activities' })

      state.items = nav
    },
    updateActiveCategory(state, category) {
      state.category = category
    },
  },
  actions: {
    setNavItems(context, payload) {
      context.commit('setNavItems', payload)
    },
    updateActiveCategory(context, payload) {
      context.commit('updateActiveCategory', payload)
    },
  },
}
